import { useCallback, useEffect, useState } from 'react';
import { fetchAllFeatures } from '../../utils/axiosRequests';

export const useAppFeatures = () => {
  const [features, setFeatures] = useState({});

  const isEnabled = useCallback(
    (key) => {
      if (!features) {
        return true;
      }
      return features[key] !== undefined ? features[key] : true;
    },
    [features],
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchAllFeatures(controller.signal)
      .then((data) => {
        setFeatures(data || {});
      })
      .catch((e) => {
        console.warn('Feature flags fetch error:', e);
      });

    return () => {
      controller.abort();
    };
  }, []);

  return { isEnabled };
};
